import { render } from "./LockItInButtons.vue?vue&type=template&id=115bb74a&scoped=true"
import script from "./LockItInButtons.vue?vue&type=script&lang=js"
export * from "./LockItInButtons.vue?vue&type=script&lang=js"

import "./LockItInButtons.vue?vue&type=style&index=0&id=115bb74a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115bb74a"]])

export default __exports__